import {
  arrayOf, shape, string,
} from 'prop-types';
import imageSetType from '../imageSetType';
import priceType from '../priceType';
import promoMessageType from '../promoMessageType';
import treatments from './treatmentsType';

const RecommendedPlacementType = shape({
  id: string.isRequired,
  name: string,
  title: string,
  products: arrayOf(shape({
    badges: arrayOf(shape({
      text: string,
      theme: string,
    })),
    collection: string,
    defaultSwatchSequence: string,
    departmentName: string,
    id: string,
    imageSet: imageSetType,
    imageUrl: string,
    kic: string,
    memberPriceOriginal: priceType,
    name: string,
    partNumber: string,
    price: string,
    priceObject: priceType,
    productPageUrl: string,
    promoMessaging: promoMessageType,
    shortDescriptors: arrayOf(string),
    swatchList: arrayOf(shape({
      id: string,
      name: string,
      product: shape({
        id: string,
        imageSet: imageSetType,
      }),
      swatchImage: string,
      sequence: string,
    })),
    swatches: arrayOf(shape({
      imageUrl: string,
      name: string,
      productId: string,
      productImageUrl: string,
      productUrl: string,
      sequence: string,
    })),
  })),
  treatments: arrayOf(shape({
    treatments,
  })),
});

export default RecommendedPlacementType;
